import { render, staticRenderFns } from "./CourseModuleForm.vue?vue&type=template&id=0839ec32&scoped=true"
import script from "./CourseModuleForm.vue?vue&type=script&lang=js"
export * from "./CourseModuleForm.vue?vue&type=script&lang=js"
import style0 from "./CourseModuleForm.vue?vue&type=style&index=0&id=0839ec32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0839ec32",
  null
  
)

export default component.exports